import {
  Box,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  styled,
  Typography,
} from "@mui/material";
import { motion } from "framer-motion";

import pxToRem from "theme/base/pxToRem";

export const DialogTitleCustom = styled(DialogTitle)(() => ({
  minWidth: pxToRem(410),
  padding: pxToRem(16),
  position: "relative",
  textAlign: "center",

  button: {
    position: "absolute",
    top: pxToRem(8),
    right: pxToRem(8),
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  lineHeight: theme.typography.lineHeight.md,
  fontSize: theme.typography.size.md_16,
  fontWeight: theme.typography.fw_semibold_600,
  color: theme.palette.text.textPrimary,
}));

export const DialogContentCustom = styled(DialogContent)(({ theme }) => ({
  padding: pxToRem(16),
  backgroundColor: theme.palette.background.bgTertiary,
}));

export const DialogActionsCustom = styled(DialogActions)(() => ({
  padding: pxToRem(16),
  flexDirection: "column",
  gap: pxToRem(18),
}));

export const Form = styled(Box)(({ theme }) => ({
  padding: pxToRem(20),
  backgroundColor: theme.palette.background.bgPrimary,
  boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.03)",
  borderRadius: pxToRem(8),
  display: "flex",
  alignItems: "center",
}));

export const UploadTitle = styled(Typography)(({ theme }) => ({
  lineHeight: theme.typography.lineHeight.md,
  fontSize: theme.typography.size.sm_14,
  fontWeight: theme.typography.fw_semibold_600,
  color: theme.palette.text.textLink,
}));

export const UploadNote = styled(Typography)(({ theme }) => ({
  lineHeight: theme.typography.lineHeight.md,
  fontSize: theme.typography.size.sm_14,
  fontWeight: theme.typography.fw_regular_400,
  color: theme.palette.text.textLink,
}));

export const CommitWrapper = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  gap: pxToRem(8),
}));

export const CountGroupButton = styled("div")(({ theme }) => ({
  marginLeft: pxToRem(24),
  borderRadius: pxToRem(8),
  border: `1px solid ${theme.palette.stroke.strokeDefault2}`,
  padding: pxToRem(4),
  width: pxToRem(132),
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
}));

export const ButtonCount = styled(Box)(({ theme }) => ({
  width: pxToRem(32),
  height: pxToRem(32),
  borderRadius: pxToRem(4),
  backgroundColor: theme.palette.background.bgTertiary,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  svg: {
    with: pxToRem(20),
    height: pxToRem(20),
    path: { fill: theme.palette.icon.icDefault },
  },
  cursor: "pointer",
}));

export const TimelineWrapper = styled(Stack)(({ theme }) => ({
  width: pxToRem(250),
  gap: pxToRem(12),
  padding: pxToRem(16),
  borderRadius: pxToRem(8),
  alignItems: "flex-start",
  backgroundColor: theme.palette.background.bgPrimary,
  height: "70vh",
  overflow: "auto",
}));

export const TimelineItem = styled(motion.div)<{ active?: boolean }>(
  ({ theme, active = false }) => ({
    width: "100%",
    padding: pxToRem(12),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderRadius: pxToRem(8),
    backgroundColor: active
      ? theme.palette.background.bgBrand
      : theme.palette.background.bgPrimary,
    cursor: "pointer",
    border: `1px solid ${
      active
        ? theme.palette.background.bgBrand
        : theme.palette.stroke.strokeDefault2
    }`,
  })
);

export const TineLineDate = styled(Typography)<{ active?: boolean }>(
  ({ theme, active = false }) => ({
    color: active
      ? theme.palette.text.textWhite
      : theme.palette.text.textPrimary,
    fontWeight: active
      ? theme.typography.fw_semibold_600
      : theme.typography.fw_regular_400,
  })
);

export const TineLineHour = styled(Typography)<{ active?: boolean }>(
  ({ theme, active = false }) => ({
    color: active
      ? theme.palette.text.textWhite
      : theme.palette.text.textSecondary,
    fontWeight: theme.typography.fw_regular_400,
  })
);

export const HistoryDetail = styled(Stack)(({ theme }) => ({
  gap: pxToRem(12),
  padding: pxToRem(16),
  borderRadius: pxToRem(8),
  flex: 1,
  minHeight: "40vh",
  maxHeight: "70vh",
  backgroundColor: theme.palette.background.bgPrimary,
  overflow: "auto",
}));

export const TableContainer = styled("table")(({ theme }) => ({
  width: "100%",
  border: `1px solid ${theme.palette.stroke.strokeDefault}`,
  borderRadius: pxToRem(8),
  borderSpacing: 0,
  overflow: "hidden",
  "tr:last-child td, tr:last-child th": {
    borderBottom: "none",
  },
  "td:last-child, th:last-child": {
    borderRight: "none",
  },
}));

export const TableRow = styled("tr")<{ isBorderBottom?: boolean }>(
  ({ theme, isBorderBottom = true }) => ({
    "td, th": {
      borderBottom: isBorderBottom
        ? `1px solid ${theme.palette.stroke.strokeDefault}`
        : "none",
      borderRight: `1px solid ${theme.palette.stroke.strokeDefault}`,
    },
  })
);

export const TableHeader = styled("th")(({ theme }) => ({
  padding: pxToRem(12),
  fontSize: theme.typography.size.sm_14,
  lineHeight: theme.typography.lineHeight.md,
  color: theme.palette.text.textPrimary,
  fontWeight: theme.typography.fw_semibold_600,
  backgroundColor: theme.palette.background.bgBase,
  whiteSpace: "nowrap",
}));

export const TableContent = styled("td")(() => ({
  padding: pxToRem(12),
}));

export const GroupTitle = styled(Typography)(({ theme }) => ({
  lineHeight: theme.typography.lineHeight.md,
  fontSize: theme.typography.size.md_16,
  fontWeight: theme.typography.fw_semibold_600,
  color: theme.palette.text.textLink,
}));

export const Info = styled(Typography)(({ theme }) => ({
  lineHeight: theme.typography.lineHeight.md,
  fontSize: theme.typography.size.sm_14,
  fontWeight: theme.typography.fw_regular_400,
  color: theme.palette.text.textPrimary,
}));

export const OldValue = styled(Typography)(({ theme }) => ({
  lineHeight: theme.typography.lineHeight.md,
  fontSize: theme.typography.size.sm_14,
  fontWeight: theme.typography.fw_regular_400,
  color: theme.palette.text.textSecondary,
}));

export const NewValue = styled(Typography)(({ theme }) => ({
  lineHeight: theme.typography.lineHeight.md,
  fontSize: theme.typography.size.sm_14,
  fontWeight: theme.typography.fw_semibold_600,
  color: theme.palette.text.textPrimary,
  whiteSpace: "pre-line",
}));

export const Note = styled(Typography)(({ theme }) => ({
  lineHeight: theme.typography.lineHeight.md,
  fontSize: theme.typography.size.sm_14,
  fontWeight: theme.typography.fw_regular_400,
  color: theme.palette.text.textPrimary,
  textAlign: "right",
}));

export const StatusApprove = styled(Typography)(({ theme }) => ({
  lineHeight: theme.typography.lineHeight.md,
  fontSize: theme.typography.size.sm_14,
  fontWeight: theme.typography.fw_semibold_600,
  color: theme.palette.text.textPositive,
  whiteSpace: "nowrap",
}));

export const StatusReject = styled(Typography)(({ theme }) => ({
  lineHeight: theme.typography.lineHeight.md,
  fontSize: theme.typography.size.sm_14,
  fontWeight: theme.typography.fw_semibold_600,
  color: theme.palette.text.textNegative,
  whiteSpace: "nowrap",
}));

export const StatusPending = styled(Typography)(({ theme }) => ({
  lineHeight: theme.typography.lineHeight.md,
  fontSize: theme.typography.size.sm_14,
  fontWeight: theme.typography.fw_semibold_600,
  color: theme.palette.text.textSecondary,
  whiteSpace: "nowrap",
}));
